<template>
  <div>
    <div style="height: 100%" v-if="load">
      <loading fullscrean="true" :text="text"/>
    </div>
    <div v-show="!load">
      <div v-show="menu === 1">
        <div class="text-center">
          <div class="card p-3 mb-3 text-left">
            <h6 class="font-weight-bold">Valor a pagar: {{pedido.valor_total | valor}}</h6>
            <div>1. Acesse seu Internet Banking ou app de pagamentos</div>
            <div>2. Escolha pagar via Pix Copia e Cola</div>
            <div>3. Copie e cole o código pix abaixo:</div>
            <div class="mt-2">
              <div class="d-flex justify-content-between mb-1">
                <input class="form-control mr-2" id="chavePix" :value="dadosPix.qr_code">
                <button class="btn btn-primary btn-block" style="width: 90px" @click="copiarChave">Copiar</button>
              </div>
            </div>
          </div>
          <div>
            <div class="mb-2">Você também pode pagar scaneando este qr code:</div>
            <div v-if="dadosPix.qr_base64">
              <img :src="`data:image/jpeg;base64,${dadosPix.qr_base64}`" alt="QrCode Pix" style="max-width: 170px">
            </div>
            <div v-if="dadosPix.qr_link">
              <img :src="`${dadosPix.qr_link}`" alt="QrCode Pix" style="max-width: 170px">
            </div>
          </div>
          <div class="mt-2">
            Código válido por: {{tempoPagamento}}<span v-show="!tempoPagamento">10:00</span> minutos
          </div>
          <hr>
          <div class="small">
            Já realizou o pagamento? <a href="javascript:" @click="recarregarPagina()">Clique aqui</a> para atualizar.
          </div>
        </div>
      </div>

      <div v-show="menu === 2">
        <aviso-informativo variante="cinza" :mostrar-icone="false" class="small mb-3">
          Por exigência do Banco Central, é necessário informar um documento para geração de pagamentos online.
        </aviso-informativo>
        <div class="card p-3 mb-2">
          <form @submit.prevent="validarDados">
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold">Informe seu CPF *</label>
              <the-mask id="cpf" type="tel" :mask="['###.###.###-##']" class="form-control" v-model="dados.cpf" placeholder="###.###.###-##" required/>
              <div class="small text-muted mt-1">Usado apenas para gerar o pagamento</div>
            </div>
            <button class="btn btn-primary btn-block mt-3" :disabled="dados.cpf.length < 11">
              Gerar Pagamento
            </button>
          </form>
        </div>
        <div class="my-3 text-muted">
          <div class="small">Concordo com os <a href="https://lecard.delivery/termos-de-uso/" target="_blank" class="text-primary font-weight-bold">Termos e Condições de uso!</a></div>
          <div class="small">Estou enviando informações verdadeiras podendo responder civilmente perante a lei.</div>
        </div>
      </div>

      <div v-show="menu === 3">
        <div class="text-center">
          <div class="card p-3 mb-4 text-left">
            <h6 class="font-weight-bold mb-2">Valor a pagar: {{pedido.valor_total | valor}}</h6>
            <div class="mb-1">Siga o passo a passo:</div>
            <div>1. Clique no botão "Realizar Pagamento"</div>
            <div>2. Selecione uma forma de pagamento</div>
            <div>3. Informe seus dados</div>
            <div>3. Pronto! Seu pedido será aprovado automaticamente</div>
          </div>
          <a :href="linkPagamento" @click="pagamentoAberto = true" target="_blank" class="btn btn-primary btn-block py-3" v-if="linkPagamento">
            Realizar Pagamento
          </a>
          <button @click="abrirPagamento()" class="btn btn-primary btn-block" v-else>
            Realizar Pagamento
          </button>
          <div class="mt-3">
            Você tem <b>{{ tempoPagamento }}</b> minutos para realizar seu pagamento.
          </div>
          <hr>
          <div class="small" v-show="pagamentoAberto">
            Já realizou o pagamento? <a href="javascript:" @click="recarregarPagina()">Clique aqui</a> para atualizar.
          </div>
        </div>
      </div>

      <div v-if="menu === 4">
        <cartoes-pagarme @selecionarCartao="selecionarCartaoPagarme"/>
      </div>

      <div v-if="menu === 5">
        <cartoes-mercadopago @atualizar="atualizar" :pedido="pedido" :dados="dados"/>
      </div>
    </div>
  </div>
</template>

<script>
import AvisoInformativo from "./AvisoInformativo";
  import Icon from "./Icon";
  import Loading from "./Loading";
  import CardInfo from "./CardInfo";
  import {TheMask} from 'vue-the-mask';
  import CartoesMercadopago from "./CartoesMercadoPago";
  import CartoesPagarme from "./CartoesPagarme";

  export default {
    name: "PixPagamento",
    components: {AvisoInformativo, CartoesPagarme, CartoesMercadopago, CardInfo, Loading, Icon, TheMask},
    props: ['empresa'],

    data() {
      return {
        token: localStorage.getItem('token'),
        load: true,
        chavePix: [],
        pedido: {},
        dadosPix: {
          qr_base64: '',
          qr_code: '',
          qr_link: ''
        },

        codigo_externo: null,
        linkPagamento: null,
        menu: 1,

        dados: {
          id_pedido: "",
          cpf: "",
          id_pagamento: ""
        },

        text: 'Gerando pagamento..',
        tempoPagamento: null,
        countDown: '',
        wasCopied: false,
        pagamentoAberto: false
      }
    },

    methods: {
      getQrCode() {
        this.load = true;
        this.menu = 1;
        const id_pedido = this.dados.id_pedido;

        this.$http.post(this.empresa.token + '/' + this.token + '/pix-mercado-pago', this.dados)
          .then(response => {
            if (response.data && response.data.result) {
              this.dadosPix = response.data;
              this.codigo_externo = response.data.codigo_externo;
              this.load = false;

            } else {
              this.$swal("Não conseguimos processar o QrCode de pagamento. Por favor tente novamente. Pedido: " + id_pedido);
              this.$emit('cancelar');
            }

          }, res => {
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar o QrCode de pagamento. Pedido: " + id_pedido + (msg ? "\nErro: " + msg : ""));
            this.$emit('cancelar');
            // this.load = false;
          });
      },

      getPreference() {
        this.load = true;
        this.menu = 3;
        let pagamento = this.$helpers.parseJSONObject(sessionStorage.getItem("linkpag" + this.dados.id_pedido));

        if (pagamento) {
          this.linkPagamento = pagamento.link;
          this.codigo_externo = pagamento.codigo_externo;
          this.load = false;
          return;
        }

        this.dados.back_url = location.href;
        const id_pedido = this.dados.id_pedido;

        this.$http.post(this.empresa.token + '/' + this.token + '/preference-mercado-pago',  this.dados)
          .then(response => {
            if (response.data && response.data.result) {
              this.load = false;
              this.linkPagamento = response.data.link;
              this.codigo_externo = response.data.codigo_externo;
              sessionStorage.setItem("linkpag" + id_pedido, JSON.stringify(response.data));

            } else {
              this.$swal("Não conseguimos processar seu pagamento. Por favor tente novamente. Pedido: " + id_pedido);
            }

          }, res => {
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar seu pagamento. Pedido: " + id_pedido + (msg ? "\nErro: " + msg : ""));
            // this.load = false;
          });
      },

      validarDados() {
        if (this.dados.cpf || this.usuario.cpf) {
          this.dados.cpf = this.dados.cpf ? this.dados.cpf : this.usuario.cpf;
        }

        if (!this.dados.cpf) {
          this.load = false;
          this.menu = 2;
          this.$swal("Por exigência do Banco Central, é necessário que informe seu CPF para que seja gerado seu pagamento online!").then(() => {
            this.$helpers.focusrElement("cpf");
          });

          return;

        } else if (!this.$helpers.validarCpf(this.dados.cpf)){
          this.load = false;
          this.menu = 2;
          this.$swal("Por favor informe um CPF válido").then(() => {
            this.$helpers.focusrElement("cpf")
          });
          return;
        }

        this.$store.state.dataUser.cpf = this.dados.cpf;
        this.dados.id_pedido = this.pedido.id_pedido;
        this.dados.origin = this.origin;

        if (this.pedido.id_pagamento === '15') {
          this.getQrCode();

        } else if (this.pedido.id_pagamento === '30'){
          this.pagamentoCartaoPagarme();

        } else if (this.pedido.id_pagamento === '31'){
          this.pagamentoQrcodePagarme();

        } else if (this.pedido.id_pagamento === '32') {
          this.pagamentoCartaoMP();

        } else {
          this.getPreference();
        }
      },

      pagamentoCartaoMP(){
        this.load = false;
        this.menu = 5;
        this.dados.id_pagamento = this.pedido.id_pagamento;
      },

      pagamentoCartaoPagarme(){
        this.load = false;
        this.menu = 4;
        this.dados.back_url = location.href;
        this.dados.id_pagamento = this.pedido.id_pagamento;
      },

      copiarChave() {
        this.wasCopied = true;
        const copyText = document.getElementById('chavePix');
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.$swal("Código copiado!","Falta pouco, agora é só colar o código em seu Internet Banking. A confirmação é automática!");
      },

      abrirPagamento() {
        this.$swal({
          text: 'Deseja abrir a tela de pagamento novamente?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            window.open(this.linkPagamento, '_target')
          }
        });
      },

      atualizar() {
        this.menu = 1;
        clearInterval(this.countDown);
        this.$emit('atualizar');
      },

      recarregarPagina() {
        this.$emit('confirmar', this.codigo_externo, this.dados.id_pedido);
      },

      selecionarCartaoPagarme(id_cartao){
        this.text = "Realizando pagamento..";
        this.load = true;
        this.dados.id_cartao = id_cartao;
        this.$http.post(this.empresa.token + '/' + this.token + '/pagarme/pagamento', this.dados)
          .then(response => {
            this.load = false;

            if (response.data) {
              if (response.data.status_pagamento === 'paid') {
                this.pagamentoAberto = true
                this.$swal("O pagamento foi realizado com sucesso.");
                this.atualizar();

              } else if (response.data.status_pagamento === 'pending') {
                this.$swal("Estamos aguardando a confirmação de pagamento, você será redirecionado para a tela de pedidos.").then(() => {
                  this.pagamentoAberto = true
                });
              }

              return;
            }

            this.$swal("O pagamento foi recusado, tente novamente.");

          }, res => {
            this.load = false;
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar seu pagamento via cartao. Pedido: " + this.dados.id_pedido + (msg ? "\nErro: " + msg : ""));            
          });
      },

      pagamentoQrcodePagarme() {
        this.load = false;
        this.menu = 1;

        this.$http.post(this.empresa.token + '/' + this.token + '/pagarme/pagamento',  this.dados)
          .then(response => {
            this.load = false;

            if (response.data.status_pagamento == 'failed') {
              this.$swal("Não foi possível gerar o Qr Code. Contato um adminstrador para mais informações!").then(() => {
                this.pagamentoAberto = true
              });

            } else {
              this.dadosPix.qr_link = response.data.qr_link;
              this.dadosPix.qr_code = response.data.qr_code;
            }

          }, res => {
            this.load = false;
            const msg = res.data ? res.data.msg : null;
            this.$swal("Não conseguimos processar seu pagamento via PIX. Pedido: " + this.dados.id_pedido + (msg ? "\nErro: " + msg : ""));
          });
      },

      openPagamento(pedido) {
        if (this.$route.query.payment_id) {
          return;
        }

        this.text = "Gerando pagamento..";
        this.pedido = pedido;
        this.tempoPagamento = null;
        this.menu = 1;

        if (this.pedido.previsao_pagamento < 0) {
          this.pagamentoExpirado();

        } else {
          this.validarDados(this.pedido);
          let timer = this.pedido.previsao_pagamento, minutes, seconds;

          if (this.pedido.previsao_pagamento) {
            clearInterval(this.countDown);

            this.countDown = setInterval(() => {
              minutes = parseInt(timer / 60, 10);
              seconds = parseInt(timer % 60, 10);

              minutes = minutes < 10 ? "0" + minutes : minutes;
              seconds = seconds < 10 ? "0" + seconds : seconds;

              this.tempoPagamento = minutes + ":" + seconds;

              if (--timer < 0) {
                this.pagamentoExpirado();
              }
            }, 1000);
          }
        }
      },

      pagamentoExpirado() {
        this.$emit('cancelar');
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },
    },

    beforeDestroy() {
      clearInterval(this.countDown);
    }
  }
</script>

<style scoped>
</style>
